import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import OfferPartnerQuestionsNewItemComponent from './OfferPartnerQuestionsNewItemComponent';
import { useValidation } from '@totalsoft/pure-validations-react';
import { required, shape, fromParent, when, concatFailure, maxLength } from '@totalsoft/pure-validations';
import { maximumCommentLength } from '../../../../../../../constants/numericLimits';

export const newQuestionValidator = shape({
  answer: fromParent(parent => [required |> when(parent.mandatory), maxLength(maximumCommentLength)] |> concatFailure)
});

const OfferPartnerQuestionsNewItemContainer = ({
  currentQuestion,
  partnerQuestions,
  questionnaire,
  onStartQuestionnaire,
  onNextQuestionnaire,
  onRealBeneficiaryClick,
  onFinishQuestionnaire,
  onSaveQuestionnaire,
  onCancelQuestionnaire,
  dispatch
}) => {
  const [questionValidation, setQuestionValidation] = useValidation(newQuestionValidator);

  useEffect(() => {
    if (questionnaire && questionnaire.loaded && partnerQuestions && currentQuestion && !currentQuestion.loaded) {
      if (partnerQuestions.length > 0) onNextQuestionnaire();
      else onStartQuestionnaire();
    }
  }, [questionnaire, partnerQuestions, currentQuestion]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (currentQuestion && currentQuestion.loaded && !currentQuestion.isEmptyQuestion) setQuestionValidation(currentQuestion);
  }, [currentQuestion, setQuestionValidation]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleOptions = () => {
    if (currentQuestion.answers && currentQuestion.answers.length > 0) return currentQuestion.answers.map(v => v.questionValue);
  };

  return currentQuestion.loaded ? (
    <OfferPartnerQuestionsNewItemComponent
      currentQuestion={currentQuestion}
      questionnaire={questionnaire}
      onStartQuestionnaire={onStartQuestionnaire}
      onNextQuestionnaire={onNextQuestionnaire}
      onRealBeneficiaryClick={onRealBeneficiaryClick}
      onFinishQuestionnaire={onFinishQuestionnaire}
      onSaveQuestionnaire={onSaveQuestionnaire}
      onCancelQuestionnaire={onCancelQuestionnaire}
      validation={questionValidation}
      options={handleOptions}
      dispatch={dispatch}
    />
  ) : (
    <></>
  );
};

OfferPartnerQuestionsNewItemContainer.propTypes = {
  currentQuestion: PropTypes.object.isRequired,
  questionnaire: PropTypes.object.isRequired,
  partnerQuestions: PropTypes.array.isRequired,
  onStartQuestionnaire: PropTypes.func.isRequired,
  onNextQuestionnaire: PropTypes.func.isRequired,
  onRealBeneficiaryClick: PropTypes.func,
  onFinishQuestionnaire: PropTypes.func.isRequired,
  onSaveQuestionnaire: PropTypes.func.isRequired,
  onCancelQuestionnaire: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: PropTypes.object
};

export default OfferPartnerQuestionsNewItemContainer;
